/* ============================================================
   Simply Wall Co. — theme interactions
   Mobile nav, cart drawer, predictive search, product gallery,
   colorway swatches, sticky mobile add-to-cart.
   Vanilla JS, no dependencies. Uses Shopify AJAX + Section APIs.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- Mobile navigation ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    if (!toggle || !drawer) return;
    var close = drawer.querySelector('[data-menu-close]');

    function open() { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); root.style.overflow = 'hidden'; toggle.setAttribute('aria-expanded', 'true'); }
    function shut() { drawer.classList.remove('is-open'); root.style.overflow = ''; toggle.setAttribute('aria-expanded', 'false'); setTimeout(function () { drawer.hidden = true; }, 350); }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) shut(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) shut(); });
  }

  /* ---------- Header on-scroll state ---------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 24);
      last = y;
    }, { passive: true });
  }

  /* ---------- Cart drawer ---------- */
  function initCart() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-cart-open]');
    var closer = drawer.querySelector('[data-cart-close]');

    function open() { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); root.style.overflow = 'hidden'; }
    function shut() { drawer.classList.remove('is-open'); root.style.overflow = ''; setTimeout(function () { drawer.hidden = true; }, 350); }

    openers.forEach(function (o) { o.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    if (closer) closer.addEventListener('click', shut);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) shut(); });

    // Delegate: add-to-cart forms submit via AJAX
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      }).then(function (r) { return r.json(); }).then(function () {
        return refreshCart();
      }).then(function () {
        open();
      }).catch(function () {}).finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
      });
    });

    window.SWC = window.SWC || {};
    window.SWC.openCart = open;
    window.SWC.refreshCart = refreshCart;
  }

  function refreshCart() {
    var body = document.querySelector('[data-cart-body]');
    return fetch('?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-body]');
      if (fresh && body) body.innerHTML = fresh.innerHTML;
      updateCartCount();
    }).catch(function () {});
  }

  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
    }).catch(function () {});
  }

  /* ---------- Product gallery (thumbnails + swipe) ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.dataset.galleryThumb;
        var slide = main.querySelector('[data-gallery-slide="' + idx + '"]');
        if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- Colorway swatches ---------- */
  function initSwatches() {
    document.querySelectorAll('[data-swatches]').forEach(function (group) {
      group.querySelectorAll('[data-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          group.querySelectorAll('[data-swatch]').forEach(function (x) { x.classList.remove('is-active'); });
          sw.classList.add('is-active');
          var input = document.querySelector('[data-variant-input="' + group.dataset.swatches + '"]');
          if (input) input.value = sw.dataset.variantId || sw.dataset.value;
          var label = group.querySelector('[data-swatch-label]');
          if (label) label.textContent = sw.dataset.value;
        });
      });
    });
  }

  /* ---------- Sticky mobile add-to-cart visibility ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- Before/After drag slider ---------- */
  function initBeforeAfter(scope) {
    (scope || document).querySelectorAll('[data-beforeafter]').forEach(function (el) {
      if (el.dataset.baInit) return;
      el.dataset.baInit = '1';
      var after = el.querySelector('[data-ba-after]');
      var handle = el.querySelector('[data-ba-handle]');
      var range = el.querySelector('[data-ba-range]');
      var dragging = false;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        el.style.setProperty('--ba', pct + '%');
        if (after) after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        if (handle) handle.style.left = pct + '%';
        if (range) range.value = pct;
        el.setAttribute('aria-valuenow', Math.round(pct));
      }
      function fromEvent(e) {
        var rect = el.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        setPos((x / rect.width) * 100);
      }
      function start(e) { dragging = true; el.classList.add('is-dragging'); fromEvent(e); }
      function move(e) { if (dragging) { fromEvent(e); if (e.cancelable) e.preventDefault(); } }
      function end() { dragging = false; el.classList.remove('is-dragging'); }

      el.addEventListener('mousedown', start);
      el.addEventListener('touchstart', start, { passive: true });
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: false });
      window.addEventListener('mouseup', end);
      window.addEventListener('touchend', end);
      if (range) range.addEventListener('input', function () { setPos(parseFloat(range.value)); });
      if (handle) handle.addEventListener('keydown', function (e) {
        var cur = parseFloat(getComputedStyle(el).getPropertyValue('--ba')) || 50;
        if (e.key === 'ArrowLeft') setPos(cur - 4);
        if (e.key === 'ArrowRight') setPos(cur + 4);
      });
      setPos(parseFloat(el.dataset.start || 50));
    });
  }

  /* ---------- Shop-the-room hotspots ---------- */
  function initHotspots(scope) {
    (scope || document).querySelectorAll('[data-hotspots]').forEach(function (el) {
      if (el.dataset.hsInit) return;
      el.dataset.hsInit = '1';
      var dots = el.querySelectorAll('[data-hotspot]');
      var cards = el.querySelectorAll('[data-hotspot-card]');
      function activate(key) {
        dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.hotspot === key); });
        cards.forEach(function (c) { c.classList.toggle('is-active', c.dataset.hotspotCard === key); });
      }
      dots.forEach(function (d) {
        d.addEventListener('mouseenter', function () { activate(d.dataset.hotspot); });
        d.addEventListener('focus', function () { activate(d.dataset.hotspot); });
        d.addEventListener('click', function () { activate(d.dataset.hotspot); });
      });
      cards.forEach(function (c) {
        c.addEventListener('mouseenter', function () { activate(c.dataset.hotspotCard); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initStickyHeader();
    initCart();
    initGallery();
    initSwatches();
    initStickyBar();
    initBeforeAfter();
    initHotspots();
    updateCartCount();
  });

  // Re-init after theme-editor section reloads
  document.addEventListener('shopify:section:load', function (e) {
    initGallery(); initSwatches(); initStickyBar();
    initBeforeAfter(e.target); initHotspots(e.target);
  });
})();
